import { Inspection } from '../../inspection/inspection.dto';
import { Injectable } from '@angular/core';
import { IndexedService, INSPECTIONS_STORE } from '@damofire/data-commons';
import { NetworkService } from '@damofire/data-angular-commons';
import { RemoteService } from './remote.service';
import { FirebaseInspectionService } from '../../inspection/firebase-inspection.service';

@Injectable()
export class InspectionRemoteService extends RemoteService<Inspection> {
  constructor(
    protected readonly idbService: IndexedService,
    protected readonly networkService: NetworkService,
    private readonly inspectionService: FirebaseInspectionService,
  ) {
    super(INSPECTIONS_STORE, idbService, networkService);
  }

  async add(division: string, data: Inspection[]): Promise<void> {
    for (const inspection of data) {
      const { issues, ...inspectionNoStats } = inspection;
      await this.inspectionService.dbCreate(inspectionNoStats);
    }
  }

  async delete(division: string, data: Inspection[]): Promise<void> {
    let deleteIssues = false;

    const ids = data.map((i) => {
      if (i.deleteIssues) {
        deleteIssues = true;
      }
      return i._id;
    });
    await this.inspectionService.deleteBatch(division, ids, deleteIssues);
  }

  async update(division: string, data: Inspection[]): Promise<void> {
    for (const inspection of data) {
      const { issues, ...inspectionNoStats } = inspection;
      await this.inspectionService.update(division, inspectionNoStats._id, inspectionNoStats);
    }
  }
}
